import React from 'react';
import { motion } from 'framer-motion';

export default function GlowShape({
  className,
  size = "w-72 h-72",
  color = "from-blue-500/25 via-purple-500/15 to-orange-500/10",
}) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
      className={`absolute rounded-full blur-3xl bg-gradient-to-br ${color} ${size} ${className} pointer-events-none`}
    />
  );
}